import namespace from '../../config/Namespace';

const types = {
  actions: {
    fetchGeneralConfig: 'fetchGeneralConfig',
    fetchFxData: 'fetchFxData',
    fetchFeeData: 'fetchFeeData',
    fetchLimitsData: 'fetchLimitsData',
    fetchScheduledSettlement: 'fetchScheduledSettlement',
    fetchGeneralConfigSuccess: 'fetchGeneralConfigSuccess',
    fetchFxDataSuccess: 'fetchFxDataSuccess',
    fetchFeeDataSuccess: 'fetchFeeDataSuccess',
    fetchLimitsDataSuccess: 'fetchLimitsDataSuccess',
    fetchScheduledSettlementSuccess: 'fetchScheduledSettlementSuccess',
    fetchCashoutLimitDataSuccess: 'fetchCashoutLimitDataSuccess',
    fetchCashoutFeeDataSuccess: 'fetchCashoutFeeDataSuccess',
    fetchIntegrationDetailsSuccess: 'fetchIntegrationDetailsSuccess',
    fetchChargebackFeeDataSuccess: 'fetchChargebackFeeDataSuccess',
    fetchReferralConfigSuccess: 'fetchReferralConfigSuccess',
    generateApiKeySuccess: 'generateApiKeySuccess',
    fetchFeeAmountRangeData: 'fetchFeeAmountRangeData',
    fetchFeeAmountRangeDataSuccess: 'fetchFeeAmountRangeDataSuccess',
    fetchRollingReserveData: 'fetchRollingReserveData',
    fetchRollingReserveSuccess: 'fetchRollingReserveSuccess',
  },
};

export default namespace('Settings', types);
